const TOKEN_KEY = 'app_tokens';
const H5_TOKEN_KEY = 'h5_token';
const USER_PROFILE_KEY = 'app_user_profile';

const storage = localStorage;

/**
 * 返回 tokens {access_token: string, refresh_token: string}
 *
 * @return {Object}
 */
export function getTokens() {
    const data = storage.getItem(TOKEN_KEY);
    return JSON.parse(data);
}

/**
 * 保存 tokens
 *
 * @param {Object} tokens {access_token: string, refresh_token: string}
 */
export function setTokens(tokens) {
    storage.setItem(TOKEN_KEY, JSON.stringify(tokens));
}

/**
 * 清除 tokens
 */
export function cleanTokens() {
    storage.removeItem(TOKEN_KEY);
    storage.removeItem(H5_TOKEN_KEY);
}

/**
 * 返回 tokens {access_token: string, refresh_token: string}
 *
 * @return {Object}
 */
export function getH5Tokens() {
    const data = storage.getItem(H5_TOKEN_KEY);
    return JSON.parse(data);
}

/**
 * 保存 tokens
 *
 * @param {Object} tokens {access_token: string, refresh_token: string}
 */
export function setH5Tokens(tokens) {
    storage.setItem(H5_TOKEN_KEY, JSON.stringify(tokens));
}

/**
 * 返回缓存的用户信息 {user: Object, authorities: Array}
 *
 * @return {Object|null}
 */
export function getCachedProfile() {
    const data = storage.getItem(USER_PROFILE_KEY);
    return data ? JSON.parse(data) : null;
}

/**
 * 缓存用户信息 {user: Object, authorities: Array}
 *
 * @param {Object} profile {user, authorities}
 */
export function setCachedProfile(profile) {
    storage.setItem(USER_PROFILE_KEY, JSON.stringify(profile));
}

/**
 * 清除缓存的用户信息
 */
export function cleanCachedProfile() {
    storage.removeItem(USER_PROFILE_KEY);
}
